import React, { useEffect, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const CustomSnackbar = ({ severity, message, open: initialOpen, handleClose, action }) => {
    const [open, setOpen] = useState(null);

    useEffect(() => {
        setOpen(initialOpen);
    }, [initialOpen]);

    return (
        <Snackbar
            open={open}
            autoHideDuration={10000}
            onClose={handleClose}
            anchorOrigin={{
                vertical: "top",
                horizontal: "center",
            }}
        >
            <Alert
                onClose={handleClose}
                severity={severity || "info"}
                sx={{ width: "100%" }}
                action={action}
            >
                {message}
            </Alert>
        </Snackbar>
    );
};

export default CustomSnackbar;